export interface AlertSettings {
  enabled: boolean;
  timing: string[]; // e.g., '15min', '1hr'
}

export interface WeeklyAvailability {
  monday: string[];
  tuesday: string[];
  wednesday: string[];
  thursday: string[];
  friday: string[];
  saturday: string[];
  sunday: string[];
}

export interface ContractorSettings {
  preferredPay: number;
  urgentPay: number;
  preferredFacilities: string[];
  searchRadius: number;
  alerts: AlertSettings;
  availability: WeeklyAvailability;
}
